var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvertedcomma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0C11.676 3.618 0 19.752 0 35.175C0 47.085 8.358 54 17.403 54C25.248 54 33 48.609 33 39.063C33 31.257 27.285 24.792 19.812 23.616C20.463 17.604 26.307 8.883 32.952 6.378L30 0ZM69 0C50.676 3.618 39 19.752 39 35.175C39 47.085 47.358 54 56.403 54C64.248 54 72 48.609 72 39.063C72 31.257 66.285 24.792 58.812 23.616C59.463 17.604 65.307 8.883 71.952 6.378L69 0Z",
    fill: "#f97316"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedcomma);
export default __webpack_public_path__ + "static/media/invertedcomma.d084a0b127b6dbcf3e0a386872ea7b8c.svg";
export { ForwardRef as ReactComponent };